import { useState, useEffect } from "react"
import nodeApiService from "../../services/nodeApiService"
import { removeEmptyFromObject } from "../../services/utils/removeEmptyFromObject"
import { sorts } from "../../services/utils/sorts"
import { useInfinitePagination } from "./useInfinitePagination"

export const useSpacesAction = (_spaces) => {
  const [spaces, setSpaces] = useState(_spaces)
  const _sorts = sorts.spaces
  const [sort, setSort] = useState(null)
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState(null)
  const { loadingMore, setPage, setShouldCall } = useInfinitePagination(
    (page) => callApi(page),
    (response) =>
      setSpaces({
        ...spaces,
        data: [...spaces.data, ...response.data],
      }),
  )

  const callApi = (page) => {
    const body = removeEmptyFromObject({ page, order: sort, search })
    if (Object.keys(body).length !== 0) {
      return nodeApiService.spaces(body)
    }
  }

  useEffect(() => {
    if (search !== null || sort !== null) {
      setLoading(true)
      setPage(1)
      setShouldCall(true)
      callApi().then((response) => {
        setSpaces(response.data)
        setLoading(false)
      })
    }
  }, [search, sort])

  return {
    spaces,
    setSearch,
    loading,
    sort,
    setSort,
    sorts: _sorts,
    loadingMore,
  }
}
